module.exports = __webpack_public_path__ + "img/cards_image.5d0facfb.png";